import { IntegrityMonitorModule } from '@nirvana/shared/dtos/types/policies/common';

// UI form value format
export interface IntegrityMonitorRealTimeFormValue {
  uiSettings: { integrityMonitor: IntegrityMonitorModule };
}

// searchable keywords
export enum IntegrityMonitorRealTimeSearchableKeywords {
  IntegrityMonitor = 'IntegrityMonitor',
  IntegrityProcessingMode = 'IntegrityProcessingMode',
  IntegrityRealTime = 'IntegrityRealTime',
}
